import React from 'react';

import { di } from 'react-magnetic-di';

import { cssMap } from '@atlaskit/css';
import { HelperMessage } from '@atlaskit/form/helper-message';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

import type { FormFieldComponentRenderer } from '../../../../../../../common/types/renderers';
import { useFormField } from '../../../../../../../controllers/form-renderer-store';

const styles = cssMap({
	helperMessageContainerStyles: {
		marginTop: token('space.negative.050'),
		marginBottom: token('space.050'),
	},
});

export const FieldHelperMessage: FormFieldComponentRenderer = ({ fieldId }) => {
	di(useFormField);
	const formField = useFormField({ fieldId });

	return (
		formField.helperMessage && (
			<Box xcss={styles.helperMessageContainerStyles}>
				<HelperMessage testId="field-helper-message">{formField.helperMessage}</HelperMessage>
			</Box>
		)
	);
};
